import * as actionTypes from '../../actions/actionTypes';
import { updateObject } from '../../utility';

const initialState = {
	data: [],
	loading: false,
};

const getColumnLifeStart = (state) => {
	return updateObject(state, { loading: true });
};

const getColumnLifeSuccess = (state, action) => {
	return updateObject(state, { data: action.data, loading: false });
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.GET_COLUMN_LIFE_START:
			return getColumnLifeStart(state, action);
		case actionTypes.GET_COLUMN_LIFE_SUCCESS:
			return getColumnLifeSuccess(state, action);

		default:
			return state;
	}
};

export default reducer;
